import request from "@/utils/request";

export default function list() {
    return request({
        url: `/mapMarker/agency/list`,
        method: 'get',
    })
}
